export default __webpack_public_path__ + "static/academicons-15e4cc4e96756f5646d2d8aa368bca80.ttf";